import setChannelDataLogic from "./setChannelDataLogic";

export default [...setChannelDataLogic];
